import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import{LoopBackAuth, validacionService} from '../services/api-rest.service';
import{MessageService} from '../services/message.service';

@Component({
  selector: 'tree-basico',
  template: `
    <ul class="lista-tree">
      <li *ngFor="let item of rama">
        <div class="d-flex justify-content-between d-flex align-items-center">
            <div>
                <span [ngStyle]="{'padding-left':(nivel *10).toString()+'px'}"> 
                <i class="ti-plus" *ngIf="item.children.length > 0" (click)="item.mostrar = !item.mostrar" [hidden]="item.mostrar"></i>
                <i class="ti-minus" *ngIf="item.children.length > 0" (click)="item.mostrar = !item.mostrar" [hidden]="!item.mostrar"></i>    
                {{item.descripcion}}
              </span>
            </div>
  
            <div>
              <div class="contact-icon">
                <button type="button" class="btn btn-default pl-2 pr-2 pb-1 pt-1" [hidden]="!activarBoton('editar') || !(item.children.length == 0)">
                    <i class="icofont icofont-ui-edit m-0 f-14 text-secondary"></i>
                </button>
                <button 
                  type="button" 
                  class="btn btn-danger pl-2 pr-2 pb-1 pt-1" 
                  [hidden]="!activarBoton('eliminar') || !(item.children.length == 0)"
                  (click)="eliminarItem(item)">
                    <i class="icofont icofont-ui-delete m-0 f-14"></i>
                </button>
                <div class="p-0 border-checkbox-section" *ngIf="activarBoton('checked') && (item.children.length == 0) && item.estado == 0">
                    <div class="border-checkbox-group">
                        <input
                            class="border-checkbox"
                            type="checkbox"
                            name="checked_{{item.id}}"
                            (checked)="item.checked"
                            (change)="seleccionar($event.target.checked,item.id)"
                            [(ngModel)] ="item.checked"
                            id="checked_{{item.id}}">
                        <label
                        class="border-checkbox-label"
                        for="checked_{{item.id}}"></label>
                    </div>
                </div>
              </div>
            </div>
        </div>
          <tree-basico 
            [rama]= "item.children"  
            [botones]="botones" 
            *ngIf="item.mostrar" 
            [nivel]="nivel+1"
            [mostrar]="mostrar"
            (emittContadorFila)="contadorItems($event)"
            (emittEliminarItem)="eliminarItem($event)">
          </tree-basico>
      </li>
    </ul>
  `,
  providers:[LoopBackAuth, validacionService,MessageService]
})
export class TreeBasicoComponent implements OnInit {
  @Input() rama
  @Input() botones = []
  @Input() nivel = 0
  @Input() mostrar = true
  @Output() emittContadorFila = new EventEmitter()
  @Output() emittEliminarItem = new EventEmitter()

  constructor(
    public  val : validacionService
  ) { }

  ngOnInit() {
    
  }

  ngOnChanges(changes:SimpleChanges) {
    
    if(changes.rama.currentValue != undefined && changes.rama.currentValue.length > 0 ){
      if(this.mostrar) this.mostrarTodo(true)
    }
      
  }

  public activarBoton(tipo){
     if(this.botones.length == 0) return false
     if(this.botones.find(x=> x == tipo) != undefined ) return true
     return false
  }

 

  public seleccionar(event,id){
    let datos = {
      event: event,
      id: id
    } 
    this.emittContadorFila.emit(datos)
  }

  public contadorItems(event){
    this.emittContadorFila.emit(event) 
  }

  public eliminarItem(item){
    this.emittEliminarItem.emit(item)
  }

  public mostrarTodo(valor){
    this.modificarNodosParametro(this.rama,'mostrar',valor, 0)
  }

  private modificarNodosParametro(rama,campo,valor,index){
    if(rama.length > 0){
      let count = 0 
      for(let hijo of rama){
        hijo[campo] = valor
        this.modificarNodosParametro(hijo.children,campo, valor,count)
      }
    }else{
      return null
    }
  }

  public adicionarNodo(item,padre,nivel,orden){
      
  }
  
  

}



// WEBPACK FOOTER //
// ./src/app/shared/element/tree-basico.component.ts